import { ArrowIcon } from "../Icons";
import { CaptionDropdowns, useDayPicker, useNavigation } from 'react-day-picker';

/**
 * Implements custom month/year navigation controls and caption for the DayPicker
 * component. Much of this code is copied out of the `react-day-picker` source and
 * then modified to fit our needs.
 */
import { jsx as _jsx, jsxs as _jsxs } from "preact/compat/jsx-runtime";
export function CustomDayPickerCaption(props) {
  const {
    classNames,
    styles,
    labels: {
      labelPrevious,
      labelNext
    },
    locale,
    onMonthChange
  } = useDayPicker();
  const {
    previousMonth,
    nextMonth,
    goToMonth
  } = useNavigation();
  const previousLabel = labelPrevious(previousMonth, {
    locale
  });
  const nextLabel = labelNext(nextMonth, {
    locale
  });

  // After navigating months, move focus to the first enabled select control
  // instead of relying on the previous/next buttons. The nav buttons can become
  // disabled at min/max date boundaries, which leads to inconsistent focus behavior.
  // The caption selects are consistently available and provide a stable focus target.
  const focusFirstEnabledCaptionControl = dialog => {
    requestAnimationFrame(() => {
      const firstFocusable = dialog?.querySelector('select:not([disabled])');
      firstFocusable?.focus();
    });
  };
  const handlePreviousClick = event => {
    if (!previousMonth) return;
    const dialog = event.currentTarget.closest('[role="dialog"]');
    goToMonth(previousMonth);
    onMonthChange?.(previousMonth);
    focusFirstEnabledCaptionControl(dialog);
  };
  const handleNextClick = event => {
    if (!nextMonth) return;
    const dialog = event.currentTarget.closest('[role="dialog"]');
    goToMonth(nextMonth);
    onMonthChange?.(nextMonth);
    focusFirstEnabledCaptionControl(dialog);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classNames.caption,
    style: styles.caption,
    children: [/*#__PURE__*/_jsx("button", {
      "aria-label": previousLabel,
      className: "ds-c-single-input-date-field__nav",
      onClick: handlePreviousClick,
      type: "button",
      disabled: !previousMonth,
      children: /*#__PURE__*/_jsx(ArrowIcon, {
        direction: "left"
      })
    }), /*#__PURE__*/_jsx(CaptionDropdowns, {
      displayMonth: props.displayMonth,
      id: props.id
    }), /*#__PURE__*/_jsx("button", {
      "aria-label": nextLabel,
      className: "ds-c-single-input-date-field__nav",
      onClick: handleNextClick,
      type: "button",
      disabled: !nextMonth,
      children: /*#__PURE__*/_jsx(ArrowIcon, {
        direction: "right"
      })
    })]
  });
}
export default CustomDayPickerCaption;